import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'

import InstallationSettingsData from './InstallationSettingsData'
import { FeedInPowerModel } from '../model'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props {
  storageId?: string
  isReadOnlyAccess?: boolean
  feedInPowerData?: FeedInPowerModel
  getFeedInPowerData: (storageId?: string) => Promise<void>
  isFeedInPowerDataLoading: boolean
  isFeedInPowerError: boolean
}

/**
 * Handles installation settings data. Includes fetching data, validating data, updating data
 */
const FeedInPowerData: FC<Props> = ({
  feedInPowerData,
  getFeedInPowerData,
  storageId,
  isReadOnlyAccess,
  isFeedInPowerDataLoading,
  isFeedInPowerError,
}) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const title = t('systemSettings.installation.settings.title')

  if (isFeedInPowerDataLoading) return

  return (
    <AccordionItem contentClassName={classes.contentAccordion} headerContentClassName={classes.headerContent} title={title} expanded>
      {feedInPowerData ? (
        <InstallationSettingsData data={feedInPowerData} storageId={storageId} updateData={getFeedInPowerData} isReadOnlyAccess={isReadOnlyAccess} />
      ) : (
        <SystemSettingsBlankView variant={isFeedInPowerError ? 'error' : 'no-data'} />
      )}
    </AccordionItem>
  )
}

export default FeedInPowerData
